export default function PageHeader({ title, subtitle, action, live }) {
  return (
    <div className="flex items-start justify-between gap-4 flex-wrap mb-8">
      <div className="min-w-0">
        <h1 className="font-heading text-3xl sm:text-4xl">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-2">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {live}
        {action}
      </div>
    </div>
  );
}
